import ItemFilter from '@/components/ItemFilter';
import MainContainer from '@/layouts/MainContainer';
import { Close } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  Modal,
  ModalProps,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';

export interface IRegionPriceModalProps extends ModalProps {
  handleClose: (value: boolean) => void;
  selectOption: Nullable<string | number>;
  setOption: (value: Nullable<string | number>) => void;
  onFilter?: (value: string) => void;
  inputLabel?: string;
}

export const FilterPriceRegionModal = ({
  children,
  title,
  handleClose,
  selectOption,
  setOption,
  onFilter,
  inputLabel = '',
  ...props
}: IRegionPriceModalProps) => {
  const theme = useTheme();

  const handleSearch = () => {
    if (onFilter && !handleClose) {
      onFilter('');
    }

    setOption(selectOption);
    handleClose(!props.open);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="modal-filter-price-region"
      aria-describedby="modal-filter-price-region"
      open={props.open}
    >
      <>
        <MainContainer
          size="md"
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: 'background.paper',
            padding: 0,
            overflow: 'hidden',
            position: 'relative',
            [theme.breakpoints.up('md')]: {
              height: '70vh',
              borderRadius: '28px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            },
          }}
        >
          <Box
            sx={{
              boxShadow: '0px 1px 1px 0px #0000001A',
              background: '#FFFFFF',
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '18px 16px',
              position: 'relative',
              zIndex: 999,
            }}
          >
            <IconButton
              data-testid="close-button"
              onClick={() => {
                onFilter && onFilter('');
                handleClose(!props.open);
              }}
              sx={{
                color: '#000000',
                position: 'absolute',
                right: 10,
              }}
            >
              <Close />
            </IconButton>
            <Typography variant="h6" component="h2">
              {title}
            </Typography>
          </Box>

          <Box
            sx={{
              height: 'calc(100% - 138px)',
              overflow: 'auto',
            }}
          >
            <MainContainer
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <ItemFilter label={inputLabel} setSearch={onFilter} />
              {children}
              <Paper
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  boxShadow: '0px 0px 1px 1px #0000001A',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '16px',
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleSearch()}
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                    width: 382,
                    height: 42,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  pesquisar
                </Button>
              </Paper>
            </MainContainer>
          </Box>
        </MainContainer>
      </>
    </Modal>
  );
};
